import { ReactNode } from 'react'
import classes from './Auth.module.css'
import ShaderBackground from '../common/components/background/ShaderBackground'

interface Props {
  children: ReactNode
}

// Gradient colors from theme to match the original CSS gradient:
// linear-gradient(192deg, primary-6 10%, secondary-7 50%, secondary-6 100%)
// primary-6: #0a6170, secondary-7: #078a78, secondary-6: #09b19a
// Shader angle -102 corresponds to CSS 192deg direction
const shaderConfig = {
  gradientColorTop: '#09b19a', // secondary-6 (lighter, at lower-left)
  gradientColorBottom: '#0a6170', // primary-6 (darker, at upper-right)
  gradientAngle: -102, // matches CSS 192deg
  blendMode: 'overlay' as const,
  u_gradientTop: 1.0, // show grid across full height
  u_timeScale: 0.8, // slightly slower animation
  gridColor: '#aaaaaa', // 0.8 gray, slightly less bright than white
  // NOTE: gridColor cannot be three letters like in CSS
}

export default function AuthLayout({ children }: Props) {
  return (
    <div className={classes.container}>
      <ShaderBackground zIndex={1} shaderConfig={shaderConfig} />
      {children}
    </div>
  )
}
